import { ModelsDatabase } from './modelsDatabase';
import { delimiter, Key } from './types';

export class ModelsDatabaseManager {
  constructor(private readonly database = new ModelsDatabase()) {}

  async clean(key: Key): Promise<void> {
    const [prefix] = key.split(delimiter);
    const models = await this.database.models.where('key').startsWith(prefix).toArray();
    const keys = models.map(({ key }) => key);
    await this.database.models.bulkDelete(keys);
  }

  async get(key: Key): Promise<ArrayBuffer> {
    const item = await this.database.models.get(key);
    if (item == null) {
      throw new Error('Cannot find model data in IndexedDB');
    }
    return item.data;
  }

  async save(key: Key, data: ArrayBuffer): Promise<void> {
    await this.database.models.put({ key, data });
  }
}
